import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Banertomumbaicabs() {



  const cardData =
  {
    keyword: ' Baner to Mumbai Cabs',
    heading: 'Sai Trupti Cabs:  Baner to Mumbai Cabs',
    headingDescription: 'Sai Trupti Cabs offers reliable and comfortable Baner to Mumbai cab services, providing a smooth and stress-free travel experience for every passenger. Our fleet includes clean, air-conditioned Sedans, SUVs, and Luxury vehicles designed for both comfort and safety. Whether you’re traveling for business, leisure, or an airport transfer, our experienced and background-verified chauffeurs ensure punctual pickups, courteous service, and a hassle-free ride. With transparent pricing, flexible booking options, and 24×7 customer support, Sai Trupti Cabs makes your journey from Baner to Mumbai seamless and enjoyable. Experience dependable intercity travel with Sai Trupti Cabs — where safety, comfort, and convenience come together for the perfect ride.',

    top: 'Top Places to Visit in Mumbai with Sai Trupti Cabs',

"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "The Gateway of India stands as Mumbai’s most iconic landmark, overlooking the Arabian Sea in majestic grandeur. Built in 1924 to commemorate King George V’s visit, it blends Indo-Saracenic architecture with colonial elegance. Tourists flock here to enjoy ferry rides to Elephanta Island and admire the sun setting behind the monument. Surrounded by historic hotels and lively street vendors, it is the perfect starting point for exploring South Mumbai’s heritage charm."
  },
  {
    "title": "Marine Drive",
    "description": "Marine Drive, famously known as the Queen’s Necklace, is a 3.6 km boulevard curving gracefully along the Arabian Sea. At night, its glittering streetlights resemble a necklace of pearls, enchanting both locals and travelers. The promenade is perfect for evening strolls, jogs, or simply sitting by the sea breeze. Watching the sunset here with the skyline of Mumbai shimmering in the background offers one of the most serene moments in the bustling metropolis."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
    "description": "A UNESCO World Heritage Site, Chhatrapati Shivaji Maharaj Terminus is a masterpiece of Victorian Gothic architecture fused with Indian artistry. Built in 1887, this grand railway station pulsates with Mumbai’s heartbeat as thousands commute daily. The ornate domes, pointed arches, and stained glass windows narrate stories of the city’s colonial past. It remains not just a transport hub but an architectural marvel symbolizing Mumbai’s vibrant spirit."
  },
  {
    "title": "Elephanta Caves",
    "description": "Situated on Elephanta Island, about 10 km from Mumbai’s shore, the Elephanta Caves are a UNESCO-listed heritage site dating back to the 5th century. These rock-cut temples are dedicated to Lord Shiva and feature magnificent sculptures, including the colossal Trimurti idol. Accessible by ferry from the Gateway of India, the island offers a mix of history, spirituality, and scenic charm. Visitors are captivated by its ancient artistry and tranquil surroundings."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is one of Mumbai’s most beloved seaside destinations, stretching over six kilometers along the Arabian coast. Locals and tourists gather here to relish iconic street foods like pav bhaji, bhel puri, and gola. The evenings come alive with laughter, vendors, and the sound of crashing waves. Watching planes land nearby at sunset makes this beach a truly cinematic Mumbai experience. It’s where relaxation meets the vibrant pulse of city life."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah stands gracefully on a tiny islet off Worli, connected to the mainland by a narrow causeway. Built in the 15th century, it houses the tomb of the revered Sufi saint Pir Haji Ali Shah Bukhari. The white marble structure surrounded by the sea exudes spiritual peace and architectural beauty. At high tide, the path gets submerged, making the shrine appear to float on water—a breathtaking symbol of faith amidst Mumbai’s urban energy."
  },
  {
    "title": "Sanjay Gandhi National Park",
    "description": "Spread across 100 square kilometers, Sanjay Gandhi National Park is a lush green oasis within the city limits of Mumbai. It offers nature trails, waterfalls, boating, and even a mini zoo for families. The ancient Kanheri Caves nestled inside the park showcase Buddhist rock-cut architecture dating back over 2,000 years. A favorite weekend escape for Mumbaikars, the park perfectly balances nature, history, and adventure in one breathtaking expanse."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "The Shree Siddhivinayak Temple in Prabhadevi is one of Mumbai’s most revered spiritual landmarks dedicated to Lord Ganesha. Built in 1801, it attracts devotees from across India, including film stars and politicians. The temple’s golden dome and intricately carved idol radiate divine grace. Devotees believe that praying here fulfills wishes, making it a hub of faith, devotion, and cultural unity in the heart of Mumbai."
  },
  {
    "title": "Colaba Causeway Market",
    "description": "Colaba Causeway is Mumbai’s vibrant shopping street known for its eclectic mix of fashion, handicrafts, antiques, and cafés. Whether you’re hunting for souvenirs, jewelry, or bohemian clothing, this market offers it all at irresistible prices. The charming colonial architecture adds to its nostalgic charm. With nearby attractions like the Gateway of India and Leopold Café, Colaba represents the city’s cosmopolitan soul and artistic flair."
  },
  {
    "title": "Bandra-Worli Sea Link",
    "description": "The Bandra-Worli Sea Link is a marvel of modern engineering connecting South Mumbai with the western suburbs. Its cable-stayed structure gleams over the Arabian Sea, especially when illuminated at night. Driving across this eight-lane bridge offers panoramic skyline views and a glimpse of Mumbai’s futuristic spirit. The Sea Link is not just a roadway but a symbol of progress, resilience, and Mumbai’s forward-moving ambition."
  }
],



"services": [
  {
    "name": "Baner to Mumbai Cabs",
    "description": "Baner to Mumbai Cabs provides reliable intercity cab services for travelers commuting between Baner and Mumbai. The service includes well-maintained vehicles, professional drivers, and timely pickups. Ideal for business trips, family travel, or airport transfers, it ensures a safe, comfortable, and stress-free journey. With transparent pricing and online booking options, passengers can plan their trips conveniently and enjoy a smooth ride along the Pune-Mumbai route."
  },
  {
    "name": "Baner to Mumbai Taxi",
    "description": "Baner to Mumbai Taxi offers convenient and secure taxi services for passengers traveling from Baner to Mumbai. The service features trained drivers, clean vehicles, and door-to-door service for a comfortable journey. Online booking, real-time tracking, and multiple payment options make it suitable for business travelers, tourists, and families looking for hassle-free intercity travel."
  },
  {
    "name": "Baner to Mumbai Car Hire",
    "description": "Baner to Mumbai Car Hire provides a wide range of vehicles for intercity travel, including hatchbacks, sedans, SUVs, and luxury cars. Customers can choose between self-drive or chauffeur-driven options. With a focus on comfort, safety, and punctuality, this service is perfect for families, corporate travelers, and tourists. Online booking, fare transparency, and 24/7 support enhance convenience and reliability."
  },
  {
    "name": "Baner to Mumbai Innova Cab",
    "description": "Baner to Mumbai Innova Cab offers spacious Toyota Innova vehicles suitable for families and groups traveling between Baner and Mumbai. The service features professional drivers, air-conditioned comfort, and smooth rides. Online reservations allow easy scheduling, fare transparency, and 24/7 assistance, making it a reliable and comfortable option for long or short intercity trips."
  },
  {
    "name": "Baner to Mumbai Ertiga Cab",
    "description": "Baner to Mumbai Ertiga Cab provides comfortable Maruti Ertiga vehicles for medium-sized groups traveling from Baner to Mumbai. The service ensures safe, smooth, and timely journeys with experienced drivers. Online booking, fare transparency, and 24/7 customer support make it ideal for family trips, group travel, or business trips along the Pune-Mumbai corridor."
  },
  {
    "name": "Baner to Mumbai Sedan Cab",
    "description": "Baner to Mumbai Sedan Cab offers mid-sized sedans for comfortable and affordable travel. Perfect for small families, corporate travelers, or solo passengers, these vehicles provide air-conditioned comfort, ample luggage space, and smooth rides. The service includes professional drivers, transparent pricing, and online booking options for a convenient and reliable intercity travel experience."
  },
  {
    "name": "Baner to Mumbai One Way Taxi",
    "description": "Baner to Mumbai One Way Taxi specializes in economical single-trip travel between Baner and Mumbai. Passengers can enjoy affordable fares without compromising on comfort or safety. The service features air-conditioned vehicles, experienced drivers, and online booking. Ideal for airport transfers, business trips, or casual travel, it ensures a smooth and timely journey for one-way trips."
  },
  {
    "name": "Baner to Mumbai Drop Cab",
    "description": "Baner to Mumbai Drop Cab provides convenient one-way drop services for travelers heading to Mumbai. The service offers hatchbacks, sedans, SUVs, and luxury vehicles with professional drivers. Customers can enjoy a safe, comfortable, and timely journey. Online booking, fare transparency, and 24/7 support make it a reliable option for business, family, or personal trips."
  },
  {
    "name": "Baner to Mumbai Outstation Cab",
    "description": "Baner to Mumbai Outstation Cab specializes in long-distance intercity travel, ensuring comfort, safety, and punctuality. The service includes a variety of vehicles maintained for smooth rides. Experienced drivers familiar with the route ensure timely pickups and drops. Online booking, fare transparency, and 24/7 assistance make this service ideal for family outings, business travel, and group trips."
  },
  {
    "name": "Baner to Mumbai Airport Taxi",
    "description": "Baner to Mumbai Airport Taxi provides dedicated airport transfer services for travelers commuting between Baner and Mumbai airports. The service guarantees timely pickups, air-conditioned vehicles, and professional drivers. Customers can book online, track rides, and access 24/7 support. Suitable for both domestic and international flights, this service ensures a stress-free and comfortable airport commute."
  },
  {
    "name": "Baner to Mumbai Luxury Cab",
    "description": "Baner to Mumbai Luxury Cab caters to travelers seeking premium travel experiences. With high-end vehicles such as BMW, Audi, and Mercedes, this service offers elegant interiors, professional chauffeurs, and top-tier comfort. Online booking, fare transparency, and 24/7 support make it ideal for business executives, VIP clients, or special occasions, ensuring a safe, luxurious, and hassle-free journey from Baner to Mumbai."
  },
  {
    "name": "Affordable Baner to Mumbai Cab",
    "description": "Affordable Baner to Mumbai Cab provides budget-friendly intercity travel without compromising on comfort or reliability. With clean vehicles, professional drivers, and transparent pricing, this service is perfect for students, families, and frequent travelers. Online booking and 24/7 assistance enhance convenience and ensure a dependable, cost-effective travel option along the Baner-Mumbai route."
  },
  {
    "name": "Baner to Mumbai Taxi Booking Online",
    "description": "Baner to Mumbai Taxi Booking Online allows passengers to reserve cabs digitally with ease. Customers can select vehicle types, schedule pickups, and receive instant confirmations. Multiple payment options, fare transparency, and online cancellations make the booking process seamless. Real-time tracking, driver details, and 24/7 support ensure a safe, reliable, and convenient intercity travel experience."
  },
  {
    "name": "Baner to Mumbai Cab near Me",
    "description": "Baner to Mumbai Cab near Me provides quick access to nearby cabs for immediate or scheduled travel between Baner and Mumbai. The service includes well-maintained vehicles, professional drivers, and fast booking options. With fare transparency, air-conditioned interiors, and reliable service, this option is perfect for travelers needing instant pickup, airport transfers, or short-notice trips."
  },
  {
    "name": "Baner to Mumbai Travel Service",
    "description": "Baner to Mumbai Travel Service offers comprehensive intercity transportation solutions, including cabs, taxis, and car rentals for trips between Baner and Mumbai. The service emphasizes safety, punctuality, and comfort with professional drivers and a variety of vehicle options. Online booking, fare transparency, and 24/7 customer support provide a convenient and reliable travel experience for families, corporate travelers, and tourists."
  }
],
"tableData": [
  ["Baner to Mumbai Cabs", "Baner to Mumbai Taxi"],
  ["Baner to Mumbai Car Hire", "Baner to Mumbai Innova Cab"],
  ["Baner to Mumbai Ertiga Cab", "Baner to Mumbai Sedan Cab"],
  ["Baner to Mumbai One Way Taxi", "Baner to Mumbai Drop Cab"],
  ["Baner to Mumbai Outstation Cab", "Baner to Mumbai Airport Taxi"],
  ["Baner to Mumbai Luxury Cab", "Affordable Baner to Mumbai Cab"],
  ["Baner to Mumbai Taxi Booking Online", "Baner to Mumbai Cab near Me"],
  ["Baner to Mumbai Travel Service", ""]
],


"whychoose": [
  {
    "WhyChooseheading": "Baner to Mumbai Cab Service",
    "WhyChoosedescription": "Sai Trupti Cabs  provides reliable and comfortable cab services from Baner (Pune) to Mumbai, perfect for business trips, airport transfers and leisure travel."
  },
  {
    "WhyChooseheading": "Transparent and Competitive Fare",
    "WhyChoosedescription": "We offer clear one‑way fares from Baner to Mumbai with no hidden charges—what you see is what you pay."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicle Options",
    "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs and premium cars to suit your group size, luggage needs and comfort preferences."
  },
  {
    "WhyChooseheading": "Experienced & Punctual Drivers",
    "WhyChoosedescription": "Our courteous, professional drivers know the Baner‑to‑Mumbai route well and ensure a safe, smooth and timely journey."
  },
  {
    "WhyChooseheading": "Flexible Pickup & Drop‑off Locations",
    "WhyChoosedescription": "We facilitate convenient pickups in Baner (and surrounding Pune suburbs) and drop‑offs across Mumbai — including airports, railway stations and city spots."
  },
  {
    "WhyChooseheading": "Clean, Well‑Maintained Vehicles",
    "WhyChoosedescription": "All our cabs are regularly serviced, sanitized and maintained to provide a comfortable ride over the long Baner‑to‑Mumbai distance."
  },
  {
    "WhyChooseheading": "24/7 Booking & Customer Support",
    "WhyChoosedescription": "Our dedicated support team is available round the clock to assist with bookings, modifications or travel queries."
  },
  {
    "WhyChooseheading": "Hassle‑Free Booking Process",
    "WhyChoosedescription": "Book your Baner to Mumbai cab easily via call, WhatsApp or our website — with instant confirmation and prompt dispatch."
  }
]






















  }

const faqData = [
  {
    question: 'Does Sai Trupti Cabs  offer Baner to Mumbai cab services?',
    answer: 'Yes, Sai Trupti Cabs  provides reliable and affordable Baner to Mumbai cab services for one way, round trip, and airport transfers.',
  },
  {
    question: 'How can I book a Baner to Mumbai cab with Sai Trupti Cabs?',
    answer: 'You can easily book your Baner to Mumbai cab through our website, mobile app, or by contacting our 24×7 customer support team.',
  },
  {
    question: 'What types of cabs are available from Baner to Mumbai?',
    answer: 'We offer hatchbacks, sedans, SUVs, tempo travellers, and luxury cars to meet your travel needs and budget.',
  },
  {
    question: 'Are the drivers experienced for the Baner to Mumbai route?',
    answer: 'Yes, all our drivers are professional, courteous, and experienced in driving on the Baner–Mumbai route, ensuring a safe and comfortable journey.',
  },
  {
    question: 'Can I book a Baner to Mumbai cab for airport transfers?',
    answer: 'Certainly. We provide dedicated Baner to Mumbai airport cab services with timely pickup and drop-off for both domestic and international terminals.',
  },
  {
    question: 'Is the Baner to Mumbai cab service available 24×7?',
    answer: 'Yes, Sai Trupti Cabs offers 24×7 cab services from Baner to Mumbai for your convenience.',
  },
  {
    question: 'What are the Baner to Mumbai cab fares?',
    answer: 'Our cab fares start from ₹1,700 for hatchbacks, ₹2,000–₹2,700 for sedans, and ₹3,300 onwards for SUVs, depending on vehicle type and travel needs.',
  },
  {
    question: 'What payment methods are accepted for Baner to Mumbai cab bookings?',
    answer: 'We accept payments via UPI, credit/debit cards, bank transfers, and digital wallets for a hassle-free booking experience.',
  },
  {
    question: 'What safety and hygiene protocols are followed for Baner to Mumbai cabs?',
    answer: 'All vehicles are sanitized before every trip, and drivers adhere to strict safety and hygiene measures to ensure a secure journey.',
  },
  {
    question: 'Is customer support available during the Baner to Mumbai cab ride?',
    answer: 'Yes, our 24×7 customer support team is available to assist you throughout your Baner to Mumbai cab journey.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Sameer Joshi',
    feedback: 'I booked a Baner to Mumbai cab with Sai Trupti Cabs. The ride was smooth, the driver was professional, and the car was very clean.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Rutuja Patil',
    feedback: 'Sai Trupti Cabs made my Baner to Mumbai trip seamless. Excellent service and timely pickup!',
    rating: 5,
  },
];

























































  const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
  { place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
  { place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
  { place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
  { place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
  { place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
  { place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
  { place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cab", link: "Hinjewadi-to-Mumbai-Cab" },
  { place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cab", link: "Wakad-to-Mumbai-Cab" },
  { place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cab", link: "Hadapsar-to-Mumbai-Cab" },
  { place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
  { place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cab", link: "Koregaon-Park-to-Mumbai-Cab" },
  { place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cab", link: "Kothrud-to-Mumbai-Cab" },
  { place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cab", link: "Kharadi-to-Mumbai-Cab" },
  { place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cab", link: "Shivajinagar-to-Mumbai-Cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cab", link: "Pune-to-Mumbai-Innova-Crysta-Cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
  { place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cab", link: "Kondhwa-to-Mumbai-Cab" },
  { place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
  { place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];
















const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Baner to Mumbai Cabs",
  "image": "https://saitrupticabs.com/assets/images/baner-to-mumbai-cabs.jpg",
  "description": "Book Baner to Mumbai Cabs with Sai Trupti Cabs for a safe, reliable, and affordable journey. Choose from AC Sedans, SUVs, and Luxury Cars for one-way, round-trip, or airport transfers. Enjoy 24/7 booking, verified drivers, and on-time service for a hassle-free ride.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Trupti Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "15432"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2499",
    "availability": "https://schema.org/InStock",
    "url": "https://saitrupticabs.com/baner-to-mumbai-cabs"
  }
};




  return (
    <div>
      <Helmet>
  <title>Baner to Mumbai Cabs | Affordable & Reliable | Sai Trupti Cabs</title>
  <meta 
    name="description" 
    content="Book Baner to Mumbai Cabs with Sai Trupti Cabs for a safe, reliable, and affordable journey. Choose from AC Sedans, SUVs, and Luxury Cars for one-way, round-trip, or airport transfers. Enjoy 24/7 booking, verified drivers, and on-time service for a hassle-free ride." 
  />
  <meta 
    name="keywords" 
    content="Baner to Mumbai Cabs, Baner to Mumbai Taxi, Baner to Mumbai Car Hire, Baner to Mumbai Innova Cab, Baner to Mumbai Ertiga Cab, Baner to Mumbai Sedan Cab, Baner to Mumbai One Way Taxi, Baner to Mumbai Drop Cab, Baner to Mumbai Outstation Cab, Baner to Mumbai Airport Taxi, Baner to Mumbai Luxury Cab, Affordable Baner to Mumbai Cab, Baner to Mumbai Taxi Booking Online, Baner to Mumbai Cab near Me, Baner to Mumbai Travel Service" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
<section
      className="breadcrumb-section"
      style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
    >
      <div className="container">
        <div className="banner-content">
          <h1> {cardData.keyword}</h1>
        </div>
      </div>
    </section>



      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/9.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sai Trupti Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Trupti Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918390907004" className="pc-call">+91 8390907004</a>
                      <a href="tel:+919922727744" className="pc-call">+91 9922727744</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918390907004"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918390907004" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@saitrupticabs.com" className="pc-email">
                      booking@saitrupticabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sai Trupti Cabs </strong><br />
                      Yashoda splendid Park,
                      Office number D. Wing Dudulgaon Anandi,
                        ruial Sainath Chowk Alandi-412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Banertomumbaicabs;